<template>
  <div>
    <div class="card datepickerwrap">
      <div class="d-flex gap-3 tw-justify-between tw-items-center">
        <div
          class="d-flex gap-3 flex-wrap tw-items-center"
          id="disparity-filters"
        >
          <div class="mr-2">
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Date"][selectedLanguage.key] }}
            </div>
            <date-range-picker
              style="width: 150px"
              v-model="lossBuyboxTableDateRange"
              :show-dropdowns="true"
              opens="right"
              :autoApply="true"
              :locale-data="{ format: 'dd mmm yyyy' }"
              :min-date="minDateTableDateRange"
              :max-date="maxDateTableDateRange"
              :single-date-picker="true"
              :ranges="false"
            >
              <!-- @update="getBuyBoxTable" -->
            </date-range-picker>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-0"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Platform"][selectedLanguage.key] }}
            </div>

            <multiselect
              @input="handlePlatformSelection"
              v-model="selectedPlatform"
              class="text-capitalize"
              :options="platformList"
              track-by="key"
              label="value"
              :custom-label="updateSelectedLabels"
              :multiple="true"
              :searchable="false"
              placeholder="Select Platform"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedPlatform?.length == platformList?.length ? 1 : 100
              "
            >
              <template #option="{ option }">
                <div class="tw-flex tw-gap-2">
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="selectedPlatform"
                  />
                  <div class="custom-option text-capitalize">
                    {{ option.value }}
                  </div>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableCategory"
              class="text-capitalize"
              :options="categoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableCategory?.length == categoryList?.length ? 1 : 100
              "
              @input="handleChangeCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTableSubCategory"
              class="text-capitalize"
              :options="subCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTableSubCategory?.length == subCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTableSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Brand"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBrand"
              class="text-capitalize"
              :options="lossBrandList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Brand"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedBrand?.length == lossBrandList?.length ? 1 : 100
              "
              @input="handleBrand"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedBrand"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <!-- <template #singleLabel="{ option }">
              {{ option.displayname.replaceAll("_", " ") }}
            </template> -->
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 220px; max-width: 220px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Price Range"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedPriceRange"
              class="text-capitalize"
              :options="lossPriceRangeList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Price Range"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                lossSelectedPriceRange?.length == lossPriceRangeList?.length
                  ? 1
                  : 100
              "
              @input="handlePriceRange"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="lossSelectedPriceRange"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 180px; max-width: 180px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Product"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedProduct"
              limit="1"
              :options="lossProductList"
              :multiple="true"
              :searchable="true"
              placeholder="Select Product"
              :close-on-select="false"
              :allow-empty="true"
              :showLabels="false"
              track-by="key"
              label="value"
              :limit="
                lossSelectedProduct?.length == lossProductList?.length
                  ? 1
                  : 1000
              "
              @input="handleProductIdSelection"
            >
              <template #option="{ option }">
                <div>
                  <input
                    type="checkbox"
                    :value="option"
                    v-model="lossSelectedProduct"
                  />
                  <span class="option__title ml-3">{{ option.value }}</span>
                </div>
              </template>
            </multiselect>
          </div>
          <div
            class="custom_pincode_dropdown customMultiselect mr-3"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1 ml-2"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Pincode"][selectedLanguage.key] }}
            </div>
            <treeselect
              v-model="lossSelectedPIN"
              :options="lossPINList"
              track-by="id"
              label="label"
              value-consists-of="LEAF_PRIORITY"
              :limit="1"
              :disable-branch-nodes="false"
              placeholder="Select PIN(s)"
              :multiple="true"
              :searchable="true"
              @select="handleSelectPinChange"
            >
              <span slot="noResult">{{
                translatedLang["No elements found"][selectedLanguage.key]
              }}</span>
            </treeselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 200px; max-width: 200px"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Batch - Time"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="lossSelectedBatch"
              class="text-capitalize"
              :options="lossBatchList"
              track-by="batch"
              label="displayname"
              :multiple="false"
              :searchable="false"
              placeholder="Select Batch"
              :showLabels="false"
              :close-on-select="true"
              :allow-empty="true"
            >
              <template #option="{ option }">
                <span class="option__title ml-3 text-capitalize">{{
                  option.displayname.replaceAll("_", " ")
                }}</span>
              </template>
              <template #singleLabel="{ option }">
                {{ option.displayname.replaceAll("_", " ") }}
              </template>
            </multiselect>
          </div>
          <button
            class="btn primarycolor py-2 tw-mt-4"
            @click="handleApplyFilters"
          >
            {{ translatedLang["Apply Filters"][selectedLanguage.key] }}
          </button>
        </div>

        <div class="ml-2 mt-2 tw-flex tw-gap-3 tw-items-center" v-if="isUserAdmin || isUserCategoryManager">
          <div
            class="tw-text-primary_brand tw-text-[14px] tw-font-[500] tw-cursor-pointer"
            @click="openTemplateModal"
          >
            Download Template
          </div>
          <div class="py-3 mx-2">
            <input
              type="file"
              class="d-none"
              accept=".xlsx"
              id="uploadfile"
              @change="uploadProductTemplate($event)"
              :disabled="isFileUploading"
            />
            <label for="uploadfile">
              <div
                class="px-4 tw-bg-[#FCB117] py-2 tw-text-[#fff] tw-font-[500] tw-text-[14px] mr-0 mb-0"
                style="border-radius: 5px !important; cursor: pointer" 
              >
                {{isFileUploading?"Uploading...":"Upload"}}
              </div>
            </label>

            <div
              v-if="Object.keys(uploadedProducts).length"
              style="color: green; font-size: 13px"
            >
              {{ uploadedProducts.file.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      size="md"
      class="customModal"
      id="templateModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showTemplateModal"
      title="Download Template"
    >
      <div class="tw-text-[14px] tw-ml-1">Select Month</div>
      <month-picker-input
        @change="showDate"
        :no-default="false"
        :default-month="date.month"
        :default-year="date.year"
        style="z-index: 1000;"
      ></month-picker-input>
      <div class="tw-flex tw-mt-4 tw-w-[100%]">
      <div
            class="customMultiselectCommon mr-2"
            style="min-width: 50%;"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTemplateCategory"
              class="text-capitalize"
              :options="templateCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTemplateCategory?.length == templateCategoryList?.length ? 1 : 100
              "
              @input="handleChangeTemplateCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTemplateCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
          <div
            class="customMultiselectCommon mr-2"
            style="min-width: 50%;"
          >
            <div
              class="mb-1"
              style="font-size: 14px; font-weight: 500; color: #1e1e1e"
            >
              {{ translatedLang["Sub Category"][selectedLanguage.key] }}
            </div>
            <multiselect
              v-model="selectedTemplateSubCategory"
              class="text-capitalize"
              :options="templateSubCategoryList"
              track-by="key"
              label="value"
              :multiple="true"
              :searchable="false"
              placeholder="Select Sub Category"
              :showLabels="false"
              :close-on-select="false"
              :allow-empty="true"
              :limit="
                selectedTemplateSubCategory?.length == templateSubCategoryList?.length
                  ? 1
                  : 100
              "
              @input="handleChangeTemplateSubCategory"
            >
              <template #option="{ option }">
                <input
                  type="checkbox"
                  :value="option"
                  v-model="selectedTemplateSubCategory"
                />
                <span class="option__title ml-3 text-capitalize">{{
                  option.value.replaceAll("_", " ")
                }}</span>
              </template>
            </multiselect>
          </div>
        </div>
      <div class="tw-float-right tw-mt-4">
        <button
          class="btn primarycolor tw-py-2"
          @click="handleDownloadTemplate"
        >
          Download
        </button>
      </div>
    </b-modal>
    <div v-if="tableLoader">
      <Loader />
    </div>
    <div class="card ml-1" style="border-radius: 10px">
      <div class="tw-flex tw-justify-between">
        <div class="d-flex overflow-auto sovReviewedTab">
          <div
            @click="handleTabPanel('Disparity')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'Disparity' === activeTab }"
          >
            Disparity
          </div>
          <div
            @click="handleTabPanel('Offers')"
            class="mx-3 font-bold tab-label"
            style="cursor: pointer"
            :class="{ active: 'Offers' === activeTab }"
          >
            Offers
          </div>
        </div>
        <div class="tw-mx-4">
          <div v-if="activeTab === 'Disparity'" class="tw-flex tw-items-center">
              <div class="tw-mr-2">
                <div style="margin-top: -5px">
                    <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
                        <b-form-radio-group class="radiohide" id="radiosBtn" buttons
                            button-variant="outline-secondary" v-model="selectedPriceFilter"
                            name="radiosBtn">
                            <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                value="equal">{{
                                    translatedLang["Equal"][selectedLanguage.key] }}</b-form-radio>
                            <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                value="low">{{
                                    translatedLang["Low"][selectedLanguage.key] }}</b-form-radio>
                            <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                value="high">{{
                                    translatedLang["High"][selectedLanguage.key] }}</b-form-radio>
                            <b-form-radio class="mx-0" style="padding: 0 8px !important"
                                value="all">{{
                                    translatedLang["All"][selectedLanguage.key] }}</b-form-radio>
                        </b-form-radio-group>
                    </b-button-toolbar>
                </div>
            </div>
            <button
                class="btn primarycolor py-2 tw-mb-2"
                @click="exportDisparityTable"
              >
                {{ translatedLang["Export"][selectedLanguage.key] }}
            </button>
          </div>
          
          <button
            v-else
            class="btn primarycolor py-2 tw-mb-2"
            @click="exportOffersTable"
          >
            {{ translatedLang["Export"][selectedLanguage.key] }}
          </button>
        </div>
      </div>
      <div class="borderBetweenTab"></div>
      <div v-show="activeTab === 'Disparity'">
        <div
          class="summaryContainer tw-mt-4"
          v-if="priceTrackingtableDataShow && tableData.length"
        >
          <table id="disparity-table" class="tw-w-full">
            <thead class="thead-normal">
              <tr>
                <th
                  v-for="(header, idx) of tableHeader"
                  :key="header.key + '|' + idx"
                >
                  <div
                    v-if="header.img"
                    class="tw-flex tw-justify-center tw-items-center tw-gap-1"
                  >
                    <img
                      :src="header.img"
                      style="width: 19px; max-height: 19px"
                    />
                    {{ header.label }}
                  </div>
                  <div v-else>{{ header.label }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(data, idx) of tableData"
                :key="data.sku + '|' + data.product_name + '|' + idx"
                class="tw-border tw-border-[#d4d4d4]"
              >
                <td
                  v-for="header in tableHeader"
                  :key="header.key + '|' + idx"
                  :class="[
                    'tw-max-w-[300px]',
                    { 'tw-max-w-[200px]': header.key === 'product_name' },
                  ]"
                >
                  <div
                    v-if="
                      data[header.key] && typeof data[header.key] === 'object'
                    "
                    @click="handleHTMLClick(data?.variant_name,data?.pincode,header.key,data[header.key]?.itemID)"
                    class="tw-flex tw-gap-8 tw-justify-center tw-cursor-pointer"
                  >
                    <div>
                      <div
                        v-if="
                          data[header.key]?.original_price == 'Out Of Stock'
                        "
                        class="outOfStockColor"
                      >
                        {{ data[header.key]?.original_price || "-" }}
                      </div>
                      <div v-else>
                        {{ data[header.key]?.original_price || "-" }}
                      </div>
                      <div
                        class="tw-mt-2 tw-flex tw-gap-1 tw-items-center text-success"
                        v-if="
                          checkPriceDiff(data[header.key]?.percentage_change) ==
                            'up' &&
                          data[header.key]?.original_price != 'Out Of Stock'
                        "
                      >
                        <img
                          style="width: 8px; height: 8px; color: green"
                          class="mb-1 mr-1"
                          src="../../../public/Icons_SVG/upPriceArrow.svg"
                        />
                        {{ data[header.key]?.percentage_change || "-" }}
                      </div>
                      <div
                        class="tw-mt-2 tw-flex tw-gap-1 tw-items-center outOfStockColor"
                        v-if="
                          checkPriceDiff(data[header.key]?.percentage_change) ==
                            'down' &&
                          data[header.key]?.original_price != 'Out Of Stock'
                        "
                      >
                        <img
                          style="width: 8px; height: 8px"
                          class="mb-1 mr-1"
                          src="../../../public/Icons_SVG/downPriceArrow.svg"
                        />
                        {{ data[header.key]?.percentage_change || "-" }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-else-if="header.key === 'product_name'"
                    @click="handleProductClick(data)"
                    class="tw-max-w-[450px] tw-whitespace-normal tw-break-words tw-cursor-pointer"
                  >
                    {{ data[header.key] }}
                  </div>
                  <div
                    v-else-if="header.key === 'variant_name'"
                    class="tw-max-w-[450px] tw-whitespace-normal tw-break-words"
                  >
                    {{ data[header.key] }}
                  </div>
                  <div v-else>
                    {{ data[header.key] }}
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          v-else-if="!priceTrackingtableDataShow && tableloader"
          class="onLoadingData mt-0"
        >
          {{ translatedLang["Loading"][selectedLanguage.key] }}...
        </div>
        <div
          v-else
          class="text-danger d-flex justify-content-center border border-danger rounded p-2 noData"
        >
          {{ translatedLang["No Data Available"][selectedLanguage.key] }}.
        </div>
      </div>
      <div v-show="activeTab === 'Offers'">
        <div
          class="summaryContainer tw-mt-4"
          v-if="Object.keys(viewOfferTableData).length"
        >
          <table id="product-offer-table" class="tw-w-full">
            <thead class="thead-normal">
              <tr>
                <th
                    v-for="(header, idx) in viewOfferTableData.headers"
                  :key="header.key + '|' + idx"
                >
                  <div
                    v-if="header.img"
                    class="tw-flex tw-justify-center tw-items-center tw-gap-1"
                  >
                    <img
                      :src="header.img"
                      style="width: 19px; max-height: 19px"
                      alt="logo"
                    />
                    {{ header.label }}
                  </div>
                  <div v-else>{{ header.label }}</div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(product, idx) in viewOfferTableData.data"
                :key="'sku' + product.sku + idx"
              >
                <td
                  v-for="header of viewOfferTableData.headers"
                  :key="header.key"
                  class="!tw-p-0"
                  style="padding: 0px !important"
                  :class="{
                    'tw-max-w-[200px] ': header.key === 'product_name',
                  }"
                >
                  <div
                    class="tw-max-w-[600px] tw-p-2 tw-text-wrap"
                    v-if="
                      header.key == 'product_name' ||
                      header.key == 'pincode' ||
                      header.key == 'variant_name'
                    "
                  >
                    {{ product[header.key] }}
                  </div>
                  <div v-else class="tw-min-w-[50px]">
                    <div
                      class="tw-border-b-[1px] tw-border-[#D9DADB] tw-py-2 tw-min-h-[40px]"
                    >
                      {{ product[header.key]?.price }}
                    </div>
                    <div
                      class="tw-border-b-[1px] tw-border-[#D9DADB] tw-py-2 tw-min-h-[40px]"
                    >
                      {{ product[header.key]?.coupon }}
                    </div>
                    <div
                      class="tw-flex tw-justify-center tw-items-center tw-py-1 tw-p-2 tw-min-h-[120px]"
                    >
                      <div v-if="product[header.key]?.offers == 'Offers'">
                        {{ product[header.key]?.offers }}
                      </div>
                      <div v-else>
                        <div
                          v-if="product[header.key]?.offers?.bank_offer_total"
                          class=""
                        >
                          Bank Offer :
                          {{ product[header.key]?.offers?.bank_offer_total }}
                        </div>
                        <div
                          v-if="
                            product[header.key]?.offers?.cashback_offers_total
                          "
                          class=""
                        >
                          Cashback Offer :
                          {{
                            product[header.key]?.offers?.cashback_offers_total
                          }}
                        </div>
                        <div
                          v-if="
                            product[header.key]?.offers?.partner_offers_total
                          "
                          class=""
                        >
                          Partner Offer :
                          {{
                            product[header.key]?.offers?.partner_offers_total
                          }}
                        </div>
                        <div
                          v-if="product[header.key]?.offers?.other_offers_total"
                          class=""
                        >
                          Other Offer :
                          {{ product[header.key]?.offers?.other_offers_total }}
                        </div>
                        <div v-if="product[header.key]?.redirect_url">
                          <a
                            :href="product[header.key]?.redirect_url"
                            target="_blank"
                            >See Details</a
                          >
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div v-else>
          <noData :loaderVariable="offerTableLoader" />
        </div>
      </div>
    </div>
    <b-modal
      size="xl"
      class="customModal"
      id="HTMLrenderModal"
      hide-footer
      style="z-index: 3000 !important; text-transform: capitalize"
      v-model="showHTMLModal"
    >
      <template #modal-title>
          <div>
              <h5 class="tw-text-[#00555A] tw-text-[16px] tw-mb-0">{{selectProductForHTML}}</h5>
          </div>
      </template>
      <div class="tw-flex-box tw-w-[100%] !tw-pt-0" id="htmlContentContainer">
        <div v-if="htmlContent">
          <div class="tw-flex  tw-mb-2">
            <div class="tw-w-[130px] mr-2 tw-px-2 tw-py-1 tw-mb-1 tw-flex-end tw-text-sm tw-border-[1px] tw-border-[#d4d4d4] tw-rounded">Pincode: {{ selectedPincodeForHTML }}</div>
            <div v-if="htmlContnetTime" class="tw-w-[310px] tw-px-2 tw-py-1 tw-mb-1 tw-flex-end tw-text-sm tw-border-[1px] tw-border-[#d4d4d4] tw-rounded">Last Updated: {{htmlContnetTime}}</div>
          </div>
          <div  v-html="htmlContent" v-if="selectedPlatformforHTML!='swiggy'"></div>
          <iframe v-else class="html-frame" :srcdoc="htmlContent"></iframe>
        </div>

        <div v-else>
          <noData :loaderVariable="htmlModalLoader" />
        </div>
      </div> 
    </b-modal>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import Datepicker from "vuejs-datepicker";
import Loader from "../Components/Loader.vue";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapState, mapActions } from "vuex";
import noData from "../Components/noData.vue";
import { MonthPickerInput } from "vue-month-picker";
import { parseDocument } from "htmlparser2";
import { parse } from "node-html-parser";

export default {
  name: "PriceTrackingDisparity",
  components: {
    Multiselect,
    Datepicker,
    Loader,
    Treeselect,
    noData,
    MonthPickerInput,
  },
  data() {
    return {
      lossBuyboxTableDateRange: {
        startDate: moment().subtract(1, "days").format("YYYY-MM-DD"),
        endDate: moment().format("YYYY-MM-DD"),
      },
      maxDate: new Date(),
      minDate: new Date(moment().subtract(1, "month")),
      date: {
        from: null,
        to: null,
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear(),
      },
      minDateTableDateRange: "",
      maxDateTableDateRange: "",
      selectedPlatform: [],
      platformList: [],
      selectedTableCategory: [],
      categoryList: [],
      categoryTableList: "",
      selectedTableSubCategory: [],
      subCategoryList: [],
      lossSelectedBrand: [],
      lossBrandList: [],
      lossSelectedProduct: [],
      lossProductList: [],
      lossSelectedPIN: [],
      lossPINList: [],
      lossSelectedBatch: [],
      lossBatchList: [],
      tableHeader: [],
      tableData: [],
      tableLoader: false,
      isFileUploading: false,
      uploadedProducts: {},
      allPincodeList: [],
      finalSelectedCategory: [],
      previousSelection: [],
      previousCategorySelection: [],
      previousSubCategorySelection: [],
      previousBrandSelection: [],
      previousProductSelection: [],
      previousPriceRangeSelection: [],
      lossSelectedPriceRange: [],
      lossPriceRangeList: [],
      storeAllDataForStatus: {},
      client: JSON.parse(localStorage.reviewUserData).data.client,
      featureId: JSON.parse(localStorage.reviewUserData).data.feature_id_map["Price_Tracking"],
      priceTrackingtableDataShow: false,
      tableloader: true,
      viewOfferTableData: {},
      activeTab: "Disparity",
      offerLoader: false,
      tableloader: true,
      viewOfferTableData: {},
      offerTableLoader: false,
      htmlModalLoader: false,
      showTemplateModal: false,
      showHTMLModal: false,
      htmlContent: null,
      htmlContnetTime: null,
      selectProductForHTML:'',
      selectedPincodeForHTML:'',
      selectedPlatformforHTML:'',
      isUserAdmin: JSON.parse(localStorage.reviewUserData)
        .data.admin,
      isUserCategoryManager: JSON.parse(
        localStorage.reviewUserData
      ).data.category_manger,
      selectedTemplateCategory:[],
      selectedTemplateSubCategory:[],
      templateCategoryList:[],
      templateSubCategoryList:[],
      previousTemplateCategorySelection:[],
      previousTemplateSubCategorySelection:[],
      // price filter variable 
      selectedPriceFilter:'all',
      storedDisparityTableData: {}
    };
  },
  mounted() {
    this.getLastUpdatedDates();
  },
  computed: {
    ...mapState("DemoStore", [
      "selectedLanguage",
      "translatedLang",
      "disparityProductDetails",
    ]),
  },
  watch: {
    selectedTableCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.subCategoryList = mergedChildren;
      if (this.selectedTableCategory?.length && this.subCategoryList.length) {
        this.subCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      this.selectedTableSubCategory = this.subCategoryList;
      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
    },
     selectedTemplateCategory(newVal) {
      let mergedChildren = [];
      newVal.forEach((cat) => {
        if (cat.child && Array.isArray(cat.child)) {
          mergedChildren.push(...cat.child);
        }
      });
      this.templateSubCategoryList = mergedChildren;
      if (this.selectedTemplateCategory?.length && this.templateSubCategoryList.length) {
        this.templateSubCategoryList.unshift({
          key: "All",
          value: "All",
        });
      }
      this.selectedTemplateSubCategory = this.templateSubCategoryList;
      this.previousTemplateSubCategorySelection = [...this.selectedTemplateSubCategory];
    },
    //  selectedPriceFilter: function () {
    //       // this.getTrendline();
    //       this.filterTablePriceData();
    // },
    selectedPriceFilter: {
        handler(newVal) {
          this.filterTablePriceData(newVal);
        },
        immediate: false
    }

  },
  methods: {
    ...mapActions("DemoStore", [
      "setSelectedLanguage",
      "setSelectedDisparityFilters",
      "initializeTranslation",
    ]),
    handleDownloadExcel(){
      // if(this.activeTab==='Disparity'){
      //   this.exportDisparityTable();
      // }
      // else if(this.activeTab==='Offers'){
      //   this.exportOffersTable();
      // }
    },
    handleSelectPinChange(newVal) {
      const selectedValue = [newVal]
      if(selectedValue.some((data)=>data.label==='All')){
        if(this.lossSelectedPIN.length>=1){
          // console.log("inside if")
          this.$nextTick(() => {
            this.lossSelectedPIN =['all'];
          });
        }
      }
      else if(selectedValue.some((data)=>data.label!=='All')){
        this.$nextTick(() => {
          this.lossSelectedPIN = this.lossSelectedPIN.filter((val) => val !=='all');
        });
      }
    },
    async filterTablePriceData(filterValue) {
        this.tableloader = true;
        this.priceTrackingtableDataShow = false;
        if ($.fn.DataTable.isDataTable("#disparity-table")) {
          $("#disparity-table").DataTable().clear().destroy();
        }

        let filter = filterValue || this.selectedPriceFilter;

        switch (filter) {
          case "all":
            this.tableData = [...this.storedDisparityTableData];
            break;
          case "high":
            this.tableData = this.storedDisparityTableData.filter(x => x.high_price);
            break;
          case "low":
            this.tableData = this.storedDisparityTableData.filter(x => x.low_price);
            break;
          case "equal":
            this.tableData = this.storedDisparityTableData.filter(x => x.equal_price);
            break;
        }

        // console.log("Filtered rows:", this.tableData.length);

        await this.$nextTick();

        setTimeout(() => {
          this.processTable("#disparity-table", 1);
          this.tableloader = true;
        }, 10);
        this.tableloader = false;
        this.priceTrackingtableDataShow=true;
    },

    // async filterTablePriceData() {
    //     this.tableData = [];
    //     // this.tableHeader = [];
    //     this.tableloader = true;
    //     if ($.fn.DataTable.isDataTable("#disparity-table")) {
    //       $("#disparity-table").DataTable().clear().destroy();
    //     }
    //      // Apply filtering
    //     switch (this.selectedPriceFilter) {
    //       case "all":
    //         this.tableData = [...this.storedDisparityTableData];
    //         break;

    //       case "high":
    //         this.tableData = this.storedDisparityTableData.filter(x => x.high_price === true);
    //         break;

    //       case "low":
    //         this.tableData = this.storedDisparityTableData.filter(x => x.low_price === true);
    //         break;

    //       case "equal":
    //         this.tableData = this.storedDisparityTableData.filter(x => x.equal_price === true);
    //         break;
    //     }
    //     // if(this.selectedPriceFilter==='all'){
    //     //   console.log("all selected")
    //     //   this.tableData= this.storedDisparityTableData;
    //     // }
    //     // else if(this.selectedPriceFilter==='high'){
    //     //   console.log("high selected")
    //     //   this.tableData = this.storedDisparityTableData.filter(key=>key.high_price===true);
    //     // }
    //     // else if(this.selectedPriceFilter==='low'){
    //     //   console.log("low selected")
    //     //   this.tableData = this.storedDisparityTableData.filter(key=>key.low_price==true);
    //     // }
    //     // else if(this.selectedPriceFilter==='equal'){
    //     //   console.log("equal selected")
    //     //     this.tableData = this.storedDisparityTableData.filter(key=>key.equal_price===true);
    //     // }
    //     console.log("filtered data-->",this.tableData);
    //     this.tableHeader= this.tableHeader;
    //     await this.$nextTick();

    //     setTimeout(() => {
    //       this.processTable("#disparity-table", 1);
    //       this.tableloader = false;
    //     }, 100);
    // },
    cleanHtml(data) {
      const temp = data.replace(/<\/?(html|body|iframe)[^>]*>/gi, "");
      return temp; // remove outer wrappers
    },

    updateSelectedLabels(option) {
      return option.value.replaceAll("_", " ");
    },
    showDate(date) {
      this.date = date;
    },
    handleApplyFilters() {
      this.priceTrackingtableDataShow = false;
      if (this.activeTab === "Disparity") {
        if ($.fn.DataTable.isDataTable("#disparity-table")) {
          $("#disparity-table").DataTable().clear().destroy();
        }
        this.getTableData();
      } else if (this.activeTab === "Offers") {
        if ($.fn.DataTable.isDataTable("#product-offer-table")) {
          $("#product-offer-table").DataTable().clear().destroy();
        }
        this.getOfferTableData();
      }
    },
    handleTabPanel(data) {
      this.activeTab = data;
      if (data === "Disparity") {
        if ($.fn.DataTable.isDataTable("#disparity-table")) {
          $("#disparity-table").DataTable().clear().destroy();
        }
        this.getTableData();
      } else if (data === "Offers") {
        if ($.fn.DataTable.isDataTable("#product-offer-table")) {
          $("#product-offer-table").DataTable().clear().destroy();
        }
        this.getOfferTableData();
      }
    },
    checkPriceDiff(value) {
      if (typeof value !== "string" && typeof value !== "number") return null;

      const cleanValue = String(value).replace("%", "").trim();
      const num = parseFloat(cleanValue);

      if (isNaN(num)) return null;
      if (num > 0) return "up";
      if (num < 0) return "down";
      return "no-change";
    },
    getLastUpdatedDates() {
      this.tableLoader = true;
      const url = `/api/v2/india_clients/last_update?client=${this.client}&feature_id=${this.featureId}`;
      this.$http
        .get(url)
        .then((response) => {
          localStorage.price_tracking_last_update = JSON.stringify(
            response.body.data.price_tracking
          );
          this.lossBuyboxTableDateRange.endDate = moment(
            response.body.data.price_tracking.end_date
          ).format("YYYY-MM-DD");
          this.lossBuyboxTableDateRange.startDate = moment(
            response.body.data.price_tracking.end_date
          ).format("YYYY-MM-DD");
          this.maxDateTableDateRange = new Date(
            response.body.data.price_tracking.end_date
          );
          // this.handlePlatformSelection()
          this.getFiltersData();
        })
        .catch((err) => {
          this.tableLoader = false;
          // this.getBrandDetails();
          console.log("err", err);
        })
        .finally(() => {
          this.tableLoader = false;
        });
    },
    handleProductClick(data) {
      this.$store.dispatch("DemoStore/setSelectedDisparityFilters", {
        ...this.$store.state.disparityProductDetails,
        selectedProduct: [{ key: data.sku, value: data.product_name }],
      });
      const productId = data.product_name;
      const url = `/price-tracking-disparity/${productId}`;
      this.$router.push(url);
    },
    handlePlatformSelection(selected) {
      const otherOptions = this.platformList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousSelection.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedPlatform = [...this.platformList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedPlatform = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedPlatform = [...this.platformList];
        } else {
          this.selectedPlatform = [...selectedWithoutAll];
        }
      }

      this.previousSelection = [...this.selectedPlatform];

      this.changeTableCategory();
    },

    changeTableCategory() {
      if (this.selectedPlatform) {
        this.selectedTableCategory = [];
        this.lossSelectedBrand = [];
        this.lossSelectedProduct = [];
        this.lossSelectedPIN = [];
        const categoryMap = new Map();
        const subCategoryMap = new Map();

        this.categoryList = [];
        this.subCategoryList = [];
        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const categories = this.allCategory[platformKey];

          if (categories?.length) {
            categories.forEach((cat) => {
              if (!categoryMap.has(cat.key)) {
                categoryMap.set(cat.key, cat);
                this.categoryList.push(cat);
              }

              if (cat.child?.length) {
                cat.child.forEach((sub) => {
                  if (!subCategoryMap.has(sub.key)) {
                    subCategoryMap.set(sub.key, sub);
                    this.subCategoryList.push(sub);
                  }
                });
              }
            });
          }
        });
        if (this.selectedPlatform.length) {
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
        }
        const stateMap = new Map();

        this.selectedPlatform.forEach((platform) => {
          const platformKey = platform.key;
          const states = this.allPincodeList[platformKey] || [];

          states.forEach((state) => {
            if (!stateMap.has(state.id)) {
              stateMap.set(state.id, {
                id: state.id,
                label: state.label,
                children: [],
              });
            }

            const stateEntry = stateMap.get(state.id);
            const cityMap = new Map(
              stateEntry.children.map((city) => [city.id, city])
            );

            state.children?.forEach((city) => {
              if (!cityMap.has(city.id)) {
                cityMap.set(city.id, {
                  id: city.id,
                  label: city.label,
                  children: [],
                });
              }

              const cityEntry = cityMap.get(city.id);
              const pinMap = new Map(
                cityEntry.children.map((pin) => [pin.id, pin])
              );

              city.children?.forEach((pin) => {
                if (!pinMap.has(pin.id)) {
                  pinMap.set(pin.id, {
                    id: pin.id,
                    label: pin.label,
                  });
                }
              });

              cityEntry.children = Array.from(pinMap.values());
            });

            stateEntry.children = Array.from(cityMap.values());
          });
        });

        this.lossPINList = Array.from(stateMap.values());
        this.handleChangeCategory();
      }
    },

    handleChangeCategory(selected) {
      if (!selected?.length) {
        this.selectedTableSubCategory = [];
      }

      const otherOptions = this.categoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected?.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTableCategory = [...this.categoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTableCategory = [];
      } else {
        const selectedWithoutAll = selected?.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTableCategory = [...this.categoryList];
        } else {
          this.selectedTableCategory = [...selectedWithoutAll];
        }
      }

      this.previousCategorySelection = [...this.selectedTableCategory];

      this.getBrandData(false);
      this.handleChangeSubCategory();
    },
     handleChangeTemplateCategory(selected) {
      if (!selected?.length) {
        this.selectedTemplateSubCategory = [];
      }

      const otherOptions = this.templateCategoryList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected?.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousTemplateCategorySelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.selectedTemplateCategory = [...this.templateCategoryList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.selectedTemplateCategory = [];
      } else {
        const selectedWithoutAll = selected?.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.selectedTemplateCategory = [...this.templateCategoryList];
        } else {
          this.selectedTemplateCategory = [...selectedWithoutAll];
        }
      }

      this.previousTemplateCategorySelection = [...this.selectedTemplateCategory];

      // this.getBrandData(false);
      // this.handleChangeSubCategory();
    },
    handleChangeSubCategory(selected) {
      if (!selected?.length) {
        this.selectedTableSubCategory = [];
      } else {
        const otherOptions = this.subCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected?.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousSubCategorySelection?.some((opt) => opt.key === "All");

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [...this.subCategoryList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedTableSubCategory = [];
        } else {
          const selectedWithoutAll = selected?.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedTableSubCategory = [...this.subCategoryList];
          } else {
            this.selectedTableSubCategory = [...selectedWithoutAll];
          }
        }
      }

      this.previousSubCategorySelection = [...this.selectedTableSubCategory];
      this.getBrandData(false);
    },
    handleChangeTemplateSubCategory(selected) {
      if (!selected?.length) {
        this.selectedTemplateSubCategory = [];
      } else {
        const otherOptions = this.templateSubCategoryList.filter(
          (p) => p.key !== "All"
        );

        const isAllCurrentlySelected = selected?.some(
          (opt) => opt.key === "All"
        );
        const wasAllPreviouslySelected =
          this.previousTemplateSubCategorySelection?.some((opt) => opt.key === "All");

        if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
          this.selectedTemplateSubCategory = [...this.templateSubCategoryList];
        } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
          this.selectedTemplateSubCategory = [];
        } else {
          const selectedWithoutAll = selected?.filter(
            (opt) => opt.key !== "All"
          );
          if (selectedWithoutAll.length === otherOptions.length) {
            this.selectedTemplateSubCategory = [...this.templateSubCategoryList];
          } else {
            this.selectedTemplateSubCategory = [...selectedWithoutAll];
          }
        }
      }

      this.previousTemplateSubCategorySelection = [...this.selectedTemplateSubCategory];
      // this.getBrandData(false);
    },
    handleBrand(selected) {
      const otherOptions = this.lossBrandList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousBrandSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedBrand = [...this.lossBrandList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedBrand = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedBrand = [...this.lossBrandList];
        } else {
          this.lossSelectedBrand = [...selectedWithoutAll];
        }
      }

      this.previousBrandSelection = [...this.lossSelectedBrand];
      this.$nextTick(() => {
        this.getProductIdData(false);
      });
    },
    handleProductIdSelection(selected) {
      const otherOptions = this.lossProductList.filter((p) => p.key !== "All");

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "All");
      const wasAllPreviouslySelected = this.previousProductSelection?.some(
        (opt) => opt.key === "All"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedProduct = [...this.lossProductList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedProduct = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "All");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedProduct = [...this.lossProductList];
        } else {
          this.lossSelectedProduct = [...selectedWithoutAll];
        }
      }

      this.previousProductSelection = [...this.lossSelectedProduct];
    },
    handlePriceRange(selected) {
      const otherOptions = this.lossPriceRangeList.filter(
        (p) => p.key !== "all"
      );

      const isAllCurrentlySelected = selected.some((opt) => opt.key === "all");
      const wasAllPreviouslySelected = this.previousPriceRangeSelection?.some(
        (opt) => opt.key === "all"
      );

      if (isAllCurrentlySelected && !wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [...this.lossPriceRangeList];
      } else if (!isAllCurrentlySelected && wasAllPreviouslySelected) {
        this.lossSelectedPriceRange = [];
      } else {
        const selectedWithoutAll = selected.filter((opt) => opt.key !== "all");
        if (selectedWithoutAll.length === otherOptions.length) {
          this.lossSelectedPriceRange = [...this.lossPriceRangeList];
        } else {
          this.lossSelectedPriceRange = [...selectedWithoutAll];
        }
      }

      this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
      this.getProductIdData();
    },

    // getAllStatusByApi() {
    //   //   console.log('kpl')
    //   let self = this;
    //   self.loaderStatus = true;
    //   const url = "api/v2/sensespiderstatus";
    //   let payload = {
    //     // "client_id": "1e5b11d71bf84ee7ac584db27d458389",
    //     timestamp: moment(this.lossBuyboxTableDateRange.endDate).format("YYYY-MM-DD"),
    //     feature: "pincode",
    //   };
    //   self.$http
    //     .post(url, payload)
    //     .then((response) => {
    //       self.storeAllDataForStatus = response.body.data;
    //       if (
    //         Object.keys(self.storeAllDataForStatus).length &&
    //         self.selectedPlatform.key !== "") {
    //         self.$store.dispatch(
    //           "DemoStore/setUpdatedStatus",
    //           self.storeAllDataForStatus[self.selectedPlatform.key]
    //         );
    //       } else {
    //         self.$store.dispatch("DemoStore/setUpdatedStatus", "");
    //       }
    //       // self.loaderStatus = false;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       self.loaderStatus = false;
    //     });
    // },
    getFiltersData(isMounted) {
      let self = this;
      self.vocProductListLoader = true;
      const url = "/api/v2/product/filter_data";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        feature_id: this.featureId,
      };
      self.$http
        .post(url, payload)
        .then((response) => {
          this.platformList = response.data.data.platform;
          if (this.platformList.length) {
            this.platformList.unshift({ key: "All", value: "All" });
          }
          this.lossPriceRangeList = response.data.data.price_range;
          this.lossSelectedPriceRange = this.lossPriceRangeList;
          this.previousPriceRangeSelection = [...this.lossSelectedPriceRange];
          this.selectedPlatform = [...this.platformList];
          this.previousSelection = [...this.selectedPlatform];
          if (Object.keys(response.data.data.batch).length) {
            this.lossBatchList = response.data.data.batch["price tracking"];
            this.lossSelectedBatch = this.lossBatchList[0];
            this.batchList = response.data.data.batch["price tracking"];
          }
          this.allCategory = response.data.data.category;
          this.categoryList = [];
          this.subCategoryList = [];
          this.templateCategoryList = [];
          this.templateSubCategoryList = [];
          const categoryMap = new Map();
          this.categoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });
           this.templateCategoryList.unshift({
            key: "All",
            value: "All",
            child: [],
          });

          this.platformList.forEach((platform) => {
            const platformKey = platform.key;
            const categories = this.allCategory[platformKey];

            if (categories?.length) {
              categories.forEach((cat) => {
                if (!categoryMap.has(cat.key)) {
                  categoryMap.set(cat.key, cat);
                  this.categoryList.push(cat);
                  this.templateCategoryList.push(cat);
                }
              });
            }
          });
          this.selectedTableCategory = this.categoryList;
          this.selectedTemplateCategory = this.templateCategoryList;
          this.previousCategorySelection = [...this.selectedTableCategory];
          this.previousTemplateCategorySelection = [...this.selectedTemplateCategory];
          const stateMap = new Map();

          this.selectedPlatform.forEach((platform) => {
            const platformKey = platform.key;
            const states = response.data.data.pincode[platformKey] || [];

            states.forEach((state) => {
              if (!stateMap.has(state.id)) {
                stateMap.set(state.id, {
                  id: state.id,
                  label: state.label,
                  children: [],
                });
              }

              const stateEntry = stateMap.get(state.id);
              const cityMap = new Map(
                stateEntry.children.map((city) => [city.id, city])
              );

              state.children?.forEach((city) => {
                if (!cityMap.has(city.id)) {
                  cityMap.set(city.id, {
                    id: city.id,
                    label: city.label,
                    children: [],
                  });
                }

                const cityEntry = cityMap.get(city.id);
                const pinMap = new Map(
                  cityEntry.children.map((pin) => [pin.id, pin])
                );

                city.children?.forEach((pin) => {
                  if (!pinMap.has(pin.id)) {
                    pinMap.set(pin.id, {
                      id: pin.id,
                      label: pin.label,
                    });
                  }
                });

                cityEntry.children = Array.from(pinMap.values());
              });

              stateEntry.children = Array.from(cityMap.values());
            });
          });

          this.lossPINList = Array.from(stateMap.values());
          this.lossSelectedPIN = this.lossPINList[1]?.children[0]?.children.map(
            (data) => data.id
          );

          this.allPincodeList = response.data.data.pincode;

          this.getBrandData(isMounted).then(() => {
            this.getTableData();
            this.getOfferTableData();
          });

          //   this.setPlatformWiseDateTable(true);
          // this.getAllStatusByApi('forBuyBoxTable');
          self.vocProductListLoader = false;
        })
        .catch((err) => {
          console.log(err);
          self.vocProductListLoader = false;
        });
    },
    async getBrandData(isMounted) {
      const url = "/api/v2/brand/data";

      if (this.selectedTableSubCategory?.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category: this.finalSelectedCategory,
        pincode: this.lossSelectedPIN?.length ? this.lossSelectedPIN : [],
        feature_id: this.featureId,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.lossBrandList = res.data.data;
        if (this.lossBrandList.length) {
          this.lossBrandList.unshift({ key: "All", value: "All" });
        }
        this.lossSelectedBrand = this.lossBrandList;
        this.$nextTick(() => {
          this.previousBrandSelection = [...this.lossSelectedBrand];
        });
        await this.getProductIdData(isMounted);
      } catch (err) {
        console.error(err);
      }
    },
    async getProductIdData(isMounted) {
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/product/data";
      let payload = {
        start_date: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        end_date: moment(this.lossBuyboxTableDateRange.endDate).format(
          "YYYY-MM-DD"
        ),
        language: this.$store.state.DemoStore.selectedLanguage.key,
        channel: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        category: this.finalSelectedCategory,
        brand: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              ?.map((brand) => brand.key)
          : [],
        feature_id: this.featureId,
      };
      try {
        const res = await this.$http.post(url, payload);
        this.lossProductList = res.data.data;
        if (this.lossProductList.length) {
          this.lossProductList.unshift({ key: "All", value: "All" });
        }

        this.lossSelectedProduct = this.lossProductList;
        this.previousProductSelection = [...this.lossSelectedProduct];
        //   this.lossSelectedProduct = [this.lossProductList[0]];
        // if (isMounted) this.getTableData();
      } catch (err) {
        console.log(err);
      }
    },
    getTableData() {
      // $("#disparity-table").DataTable().destroy();
      this.tableData = [];
      this.tableHeader = [];
      this.tableLoader = true;
      this.tableloader = true;
      this.priceTrackingtableDataShow = false;
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }

      const url = "/api/india_clients/batch/price_tracking/table";
      const payload = {
        platforms: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        category_ids: this.finalSelectedCategory,
        brand_names: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        product_sku: this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((sku) => sku.key !== "All")
              ?.map((sku) => sku.key)
          : [],
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        pincodes: this.lossSelectedPIN,
        timestamp: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        batch: this.lossSelectedBatch?.batch,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.priceTrackingtableDataShow = res.data.data_present;
          this.$store.dispatch("DemoStore/setSelectedDisparityFilters", {
            selectedDateRange: {
              startDate: this.lossBuyboxTableDateRange.startDate,
              endDate: this.lossBuyboxTableDateRange.endDate,
            },
            selectedPlatform: this.selectedPlatform,
            selectedBrand: this.lossSelectedBrand,
            selectedPincode: this.lossSelectedPIN,
            selectedPriceRange: this.lossSelectedPriceRange,
            selectedCategory: this.selectedTableCategory,
            selectedSubCategory: this.selectedTableSubCategory,
            selectedBatch: this.lossSelectedBatch,
          });
          this.tableHeader = res.data.data.headers;
          //   this.tableData = res.data.data.data;
          this.tableData = res.data.data.data.map((item) => {
            const row = {
              sku: item.sku,
              product_name: item.product_name,
              variant_name: item.variant_name,
              mrp: item.mrp,
              pincode: item.pincode,
              equal_price: item.equal_price,
              high_price: item.high_price,
              low_price: item.low_price,
            };

            const platforms = item.platform || {};
            const platformList = this.platformList?.map((data) => data.key);
            for (const platformKey of platformList) {
              const plat = platforms[platformKey];
              if (plat) {
                row[platformKey] = {
                  original_price: plat.original_price,
                  price_change: plat.price_change,
                  percentage_change: plat.percentage_change,
                  itemID: plat.item_id,
                };
              } else {
                row[platformKey] = null;
              }
            }

            return row;
          });
          this.storedDisparityTableData = this.tableData;
          this.selectedPriceFilter='all';
          this.$nextTick(() => {
            this.processTable("#disparity-table", 1);
          });
          this.tableLoader = false;
        })
        .catch((err) => {
          console.error(err);
          this.tableLoader = false;
        });
    },
    getOfferTableData() {
      // $("#disparity-table").DataTable().destroy();
      this.viewOfferTableData = {};
      this.offerLoader = true;
      this.offerTableLoader = true;
      if (this.selectedTableSubCategory.length) {
        this.finalSelectedCategory = this.selectedTableSubCategory
          ?.filter((item) => item.key !== "All")
          .map((subcat) => subcat.key);
      } else if (
        !this.selectedTableSubCategory.length &&
        this.selectedTableCategory.length
      ) {
        this.finalSelectedCategory = this.selectedTableCategory?.flatMap(
          (data) => {
            return data.child?.map((subcat) => subcat.key);
          }
        );
      } else {
        this.finalSelectedCategory = [];
      }
      const url = "/api/v2/indian_clients/price_tracking/disparity_offers";
      const payload = {
        platform: this.selectedPlatform
          ?.filter((platform) => platform.key !== "All")
          .map((platform) => platform.key),
        section_id: this.finalSelectedCategory,
        brand_name: this.lossSelectedBrand?.length
          ? this.lossSelectedBrand
              ?.filter((p) => p.key !== "All")
              .map((brand) => brand.key)
          : [],
        sku: this.lossSelectedProduct?.length
          ? this.lossSelectedProduct
              ?.filter((sku) => sku.key !== "All")
              ?.map((sku) => sku.key)
          : [],
        price_range: this.lossSelectedPriceRange?.length
          ? this.lossSelectedPriceRange
              ?.filter((price) => price.key !== "all")
              .map((price) => price.key)
          : [],
        pincode: this.lossSelectedPIN,
        timestamp: moment(this.lossBuyboxTableDateRange.startDate).format(
          "YYYY-MM-DD"
        ),
        batch: this.lossSelectedBatch?.batch,
        feature_id: this.featureId,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          this.viewOfferTableData = res.data.data;
          this.$nextTick(() => {
            this.processTable("#product-offer-table");
          });
          this.offerLoader = false;
        })
        .catch((err) => {
          this.offerLoader = false;
          this.tableLoader = false;
          this.offerTableLoader = false;
        })
        .catch((err) => {
          this.tableLoader = false;
          this.offerTableLoader = false;
          console.error(err);
        });
    },
    processTable(id) {
      // $(id).DataTable().destroy();
      $(id).DataTable({
        searching: true,
        info: true,
        order: [],
        ordering: true,
        search: {
            regex: true,
            smart: false
          },
        // scrollY: scrollVertical || false,
        initComplete: function (settings, json) {
          $(id).wrap(
            "<div style='overflow:auto; width:100%;position:relative;'></div>"
          );
        },
        language: {
          search: "",
          searchPlaceholder: "Search...",
          paginate: {
            first: "",
            previous: "<",
            next: ">",
            last: "",
          },
          lengthMenu: "<h5>Show entries</h5> _MENU_",
        },
      });
      var legends = $(`
        <div class="tw-text-sm tw-w-[50%] tw-mt-1" style="background-color:white; display:flex; gap: 10px;">
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold">NL :</span>
            <span class="tw-ml-1"> Not Listed</span>
          </div>
          <div class="legend-item tw-w-full tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold">NF :</span>
            <span class="tw-ml-1"> Not Found</span>
          </div>
          <div class="legend-item tw-w-[400px] tw-text-[12px]" style="background-color:white; ">
            <span class="tw-font-bold tw-text-[#DB1010]">OOS : </span>
            <span class="tw-ml-1 "> Out of Stock</span>
          </div>
        </div>
      `);
      if(this.activeTab==="Disparity"){
        $(id+"_filter").prepend(legends); 
      }
        // Style the filter container to use flexbox
      $(id+"_filter").css({
        'display': 'flex',
        'background': 'none',
        'justify-content': 'end',
      });
      $(id + "_filter > label").append(`
        <div class='search_icon'>
            <img src='/Icons_SVG/Search.svg' width='20' />
        </div>
      `);
      $(id).wrap(
        "<div style='overflow:auto; width:100%;position:relative;'></div>"
      );
      var btn = $(
        '<input type="button" class="btn exportBtn" value="Export" id="exportBtn"/>'
      );
      // $(id+"_filter > label").append(btn);

      $("#exportBtn").click(() => {
        this.handleDownloadExcel()
      });
    },
    openTemplateModal() {
      this.showTemplateModal = true;
    },
    handleDownloadTemplate() {
      const url = `/api/india_clients/download/product?month=${this.date.monthIndex}&&year=${this.date.year}&&categories=${JSON.stringify(this.selectedTemplateSubCategory
        .filter((item) => item.key !== "All")
        .map((cat) => cat.key))}`;

      this.$http
        .get(url)
        .then((res) => {
          this.showTemplateModal = false;
          window.location = res.data.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    uploadProductTemplate(e) {

      this.uploadedProducts = {
        ...this.uploadedProducts,
        file: e.target.files[0],
      };
      this.isFileUploading = true;
      const url = "/api/india_clients/download/product";
      const payload = new FormData();
      payload.append("file", this.uploadedProducts.file);

      this.$http
        .post(url, payload)
        .then((res) => {
          this.isFileUploading = false;
          this.uploadedProducts = {};
          // console.log(res.data);
           this.$bvToast.toast(`Succes: ${res.data?.data?.success}, Failed: ${res.data?.data?.failed}`, {
            title: 'Weavr Sense',
            variant: 'success',
            toaster: 'b-toaster-bottom-center',
            autoHideDelay: 3000,
          })
        })
        .catch((err) => {
          this.isFileUploading = true;
          console.error(err);
        });
    },
    exportDisparityTable() {
      const url =
        "/api/indian_clients/batch/price_tracking_disparity_excel_report";

      const payload = {
        headers: this.tableHeader,
        data: this.tableData,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    exportOffersTable() {
      const url = "api/indian_clients/batch/price_tracking_offers_excel_report";

      const payload = {
        headers: this.viewOfferTableData.headers,
        data: this.viewOfferTableData.data,
      };

      this.$http
        .post(url, payload)
        .then((res) => {
          window.location = res.data.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    handleHTMLClick(selectedProduct,pincode, platformKey, itemId) {
      // console.log(pincode, platformKey, itemId);
      this.selectedPlatformforHTML = platformKey;
      this.selectProductForHTML = ''
      this.selectedPincodeForHTML=''
      this.selectedPincodeForHTML = pincode;
      this.selectProductForHTML = selectedProduct;
      this.showHTMLModal = true;
      this.fetchHTML(pincode, platformKey, itemId);
    },
    fetchHTML(pincode, platformKey, itemId) {
      this.htmlModalLoader = true;
      this.htmlContent = null;
      const url = "/api/v2/india_clients/render_html/price";

      const payload = {
        timestamp: moment(this.lossBuyboxTableDateRange.endDate).format("YYYY-MM-DD"),
        identifier: pincode.toString(),
        match: itemId,
        platform: platformKey,
        batch: this.lossSelectedBatch.batch,
      };

      this.$http
        .post(url, payload)
        .then((response) => {
          const html = response.body.data;
          this.htmlContnetTime= response.body.time
          // const parseHtml= html.replace(/<\/?(html|body|head|iframe)[^>]*>/gi, "").trim();
          this.htmlContent = html
        })
        .catch((error) => {
          this.htmlModalLoader = false;
          console.error("Error fetching HTML:", error);
        });
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>

.btn-outline-secondary:not(:disabled):not(.disabled):active,
.btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #ffffff !important;
  background-color: var(--primary_brand-80) !important;
  border-color: var(--primary_brand-80) !important;
  line-height: 35px !important;
  padding: 0px 20px !important;
  border-radius: 5px !important;
  font-weight: 600 !important;
}

.btn-outline-secondary {
  line-height: 35px !important;
  /* border-radius: 5px; */
  color: var(--primary_brand) !important;
  background: var(--primary_brand-10) !important;
  border: 1px solid var(--primary_brand-10) !important;
  font-family: "poppins" !important;
  padding: 0px 20px !important;
}

.btn-group {
  background: var(--primary_brand-10) !important;
  border-radius: 5px !important;
  font-family: "poppins" !important;

  /* border: 1px solid var(--primary_brand-10); */
}
.card {
  border-radius: 0.7rem !important;
  border: none !important;
  margin-bottom: 1rem;
}
.outOfStockColor {
  color: #c00000;
}
.borderBetweenTab {
  border-bottom: 1px solid rgba(213, 213, 213, 1) !important;
  margin-bottom: 15px !important;
}
button.primarycolor {
  background: var(--primary_brand);
  font-family: "Poppins", sans-serif;
  color: white;
  padding: 5px 25px;
  border-radius: 6px;
  font-weight: bold;
  font-size: 14px;
}

button.primarycolor:hover {
  color: white;
  background: var(--primary_brand-80);
}
.navigationButton {
  height: 35px;
  border: none;
  margin: 0;
  background: var(--accent_color);
  color: white;
  border-radius: 5px;
  font-size: 16px;
  font-weight: bold;
  padding: 0px 20px;
  letter-spacing: 0.2px;
  font-family: "poppins";
}

.navigationButton:hover {
  background: var(--accent_color-80);
}
.borderBottom {
  border-bottom: 1px solid rgba(212, 212, 212, 1) !important;
  margin: 5px 0px !important;
}
.graphHeading {
  font-weight: 600 !important;
  font-size: 20px !important;
  color: var(--primary_brand) !important;
  letter-spacing: 0.6px !important;
  font-family: "poppins";
  margin-bottom: -20px !important;
}
.tab-label {
  cursor: pointer;
  padding-bottom: 5px;
  transition: all 0.3s ease;
  font-size: 16px;
  font-weight: 500;
}

.tab-label.active {
  color: rgba(6, 85, 89, 1);
  border-bottom: 1px solid rgba(6, 85, 89, 1);
  font-weight: 600 !important;
}
</style>
<style>
.html-frame{
  width: 100%;
  height: 80vh;
  border: none;
}
#htmlContentContainer .header-wrap .header[data-v-73cbb32e]{
  position:absolute;
}

#disparity-filters .multiselect__strong {
  display: none !important;
}

#templateModal .month-picker-input {
  width: 460px !important;
}
@media (min-width: 1200px) {
  #HTMLrenderModal .modal-xl {
    max-width: 1600px;
  }
}
</style>
<style >
  #disparity-table_filter .exportBtn {
  margin: 0px 10px;
  height: 30px;
  width: 80px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#disparity-table_filter .exportBtn:hover {
  background: var(--primary_brand-80);
}
 #product-offer-table_filter .exportBtn {
  margin: 0px 10px;
  height: px;
  width: 80px;
  border: none;
  background: var(--primary_brand);
  color: white;
  border-radius: 5px !important;
  font-weight: 600;
  padding: 0px !important;
  letter-spacing: 0.2px;
}

#product-offer-table_filter .exportBtn:hover {
  background: var(--primary_brand-80);
}
</style>
